var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.3 19.3",
    style: {
      enableBackground: "new 0 0 19.3 19.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFA50D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,9.3C16.8,6.6,13.3,5,9.7,4.9C6,5,2.6,6.6,0.1,9.3C0,9.5,0,9.8,0.1,10c2.4,2.7,5.9,4.3,9.5,4.4 c3.6-0.1,7.1-1.7,9.5-4.4C19.4,9.8,19.4,9.5,19.2,9.3z M13.5,9.7c-0.1,2.1-1.8,3.7-3.9,3.7c-2,0.1-3.8-1.4-3.9-3.5 C5.6,7.8,7.2,6.1,9.2,6c0.1,0,0.3,0,0.4,0C11.8,5.9,13.5,7.6,13.5,9.7z M1.3,9.7c1.3-1.2,2.7-2.2,4.4-2.9c-1.4,1.7-1.4,4.1,0,5.8 C4.1,11.9,2.6,10.9,1.3,9.7L1.3,9.7z M13.6,12.6c1.4-1.7,1.4-4.1,0-5.8c1.6,0.7,3.1,1.7,4.4,2.9C16.7,10.9,15.3,11.9,13.6,12.6 L13.6,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,9.7c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2h0C8.6,7.6,7.6,8.6,7.6,9.7z M10.5,9.7c0,0.5-0.4,0.8-0.8,0.8 s-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8l0,0C10.1,8.8,10.5,9.2,10.5,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,2.6c0.3,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0V0.6C10.3,0.3,10,0,9.7,0S9.1,0.3,9.1,0.6V2 C9.1,2.3,9.3,2.6,9.7,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,3.4c0.3,0.2,0.6,0.1,0.8-0.2l0.8-1.4c0.2-0.3,0.1-0.6-0.1-0.8s-0.6-0.1-0.8,0.1c0,0-0.1,0.1-0.1,0.1 l-0.8,1.4C12.6,2.9,12.7,3.2,13,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,3.2c0.2,0.3,0.6,0.3,0.8,0.1c0.2-0.2,0.3-0.5,0.2-0.7L5.8,1.2C5.6,0.9,5.3,0.7,5,0.9 C4.7,1,4.5,1.3,4.7,1.6c0,0,0,0.1,0.1,0.1L5.5,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,16.8c-0.3,0-0.6,0.3-0.6,0.6l0,0v1.4c0,0.3,0.3,0.6,0.7,0.5c0.3,0,0.5-0.2,0.5-0.5v-1.4 C10.3,17,10,16.8,9.7,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,16c-0.3-0.2-0.6-0.1-0.8,0.2l-0.8,1.4c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1 c0,0,0.1-0.1,0.1-0.1l0.8-1.4C6.7,16.5,6.6,16.1,6.3,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,16.2c-0.1-0.3-0.5-0.4-0.8-0.3s-0.4,0.5-0.3,0.8c0,0,0,0.1,0.1,0.1l0.8,1.4c0.1,0.3,0.5,0.4,0.8,0.3 s0.4-0.5,0.3-0.8c0,0,0-0.1-0.1-0.1L13.8,16.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.7da244d8.svg";
export { ForwardRef as ReactComponent };